import React, { useEffect } from 'react';
import { PlayProvider, CanToggleElement, CanMoveElement } from "@playhtml/react";

import Content from './Content';
import Test from './Test';
import styles from './App.module.css';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const router = createBrowserRouter([{
  path: "/",
  element: <Content />,
}]);






function calcValues() {
  const centerContent = document.getElementById('center-content');
  const centerFold = document.getElementById('center-fold');

  const overflowHeight = centerContent.clientHeight - centerFold.clientHeight;

  document.body.style.height = overflowHeight + window.innerHeight + 'px';
  const foldsContent = Array.from(
    document.querySelectorAll('[data-fold-content="true"]'),
  );
  const tick = () => {
    const scroll = -(
      document.documentElement.scrollTop || document.body.scrollTop
    );
    foldsContent.forEach(content => {
      content.style.transform = `translateY(${scroll}px)`;
    });
    requestAnimationFrame(tick);
  };

  tick();
}

const SECTIONS = [
  { hash: '#root', label: 'ZEMOJ.TEL' },
    { hash: '#cats', label: 'Cats' },

  { hash: '#picknplace', label: 'Pick n\' Place' },
  { hash: '#card-game', label: 'Game Jam Card Game' },
  { hash: '#cart-crawl', label: 'Cart Crawl' },
  { hash: '#vr-wand', label: 'VR Wand' },
  { hash: '#tube-system', label: 'Tube System' },
  { hash: '#multiplayer-ik', label: 'Multiplayer IK' },
  { hash: '#inlet', label: 'Inlet (5 Hour Game)' },
    { hash: '#music', label: 'Music' },



];

function getSectionOffset(hash) {
  const centerContent = document.getElementById('center-content');
  const target = hash && centerContent.querySelector(hash);
  if (!target) return null;

  return target.getBoundingClientRect().top - centerContent.getBoundingClientRect().top;
}

function scrollToHash(hash, behavior = 'smooth') {
  const offset = getSectionOffset(hash);
  if (offset === null) return false;

  const maxScroll = document.body.scrollHeight - window.innerHeight;

  window.scrollTo({ top: Math.min(offset, maxScroll), behavior });
  return true;
}

function getActiveSection() {
  const scroll = document.documentElement.scrollTop || document.body.scrollTop;
  const maxScroll = document.body.scrollHeight - window.innerHeight;
  if (scroll >= maxScroll - 1) return SECTIONS[SECTIONS.length - 1].hash;

  let active = null;
  SECTIONS.forEach(({ hash }) => {
    const offset = getSectionOffset(hash);
    if (offset !== null && offset <= scroll + 1) active = hash;
  });
  return active;
}

function scrollToSection(event) {
  const hash = event.currentTarget.getAttribute('href');
  if (!scrollToHash(hash)) return;

  event.preventDefault();
  window.history.replaceState(null, '', hash);
}

function alignToCurrentHash() {
  scrollToHash(window.location.hash, 'auto');
}

function lockFoldScroll(event) {
  const el = event.target;
  if (el instanceof Element && el.closest('#sectionroot')) {
    el.scrollTop = 0;
    el.scrollLeft = 0;
  }
}



function App() {
  useEffect(() => {
    window.addEventListener('resize', calcValues);
    window.addEventListener('hashchange', alignToCurrentHash);
    document.addEventListener('scroll', lockFoldScroll, true);
    calcValues();
    alignToCurrentHash();

    const onLoad = () => {
      calcValues();
      alignToCurrentHash();
    };
    if (document.readyState === 'complete') onLoad();
    else window.addEventListener('load', onLoad);
  }, []);

  const [activeSection, setActiveSection] = React.useState(null);

  useEffect(() => {
    const updateActiveSection = () => setActiveSection(getActiveSection());
    window.addEventListener('scroll', updateActiveSection);
    window.addEventListener('resize', updateActiveSection);
    window.addEventListener('load', updateActiveSection);
    updateActiveSection();
  }, []);

const [backgroundColour, setBackgroundColour] = React.useState("#1c71d8");

function handleColorChange(input) {
  
  console.log(input)
  const lightness = getLightnessFromHex(input);
  const oppositeColor = lightness > 60 ? 'black' : 'white';

  document.documentElement.style.setProperty('--main-bg-color', input);
  document.documentElement.style.setProperty('--opposite-color', oppositeColor);

  setBackgroundColour(input); // THIS triggers re-render
}


  return (
    <section >
      <PlayProvider
        initOptions={{
          cursors: {
            enabled: true,

            shouldRenderCursor: (presence) => {
              // Only render cursors from the same page
              return presence.page === window.location.pathname;
            }
          }
        }}
      >


        <div className={styles.all} id='gridparent'>

          <div id='sidebarroot'>

            



            <ul>
              {SECTIONS.map(({ hash, label }) => (
                <li key={hash} className={hash === activeSection ? 'inverted' : undefined}>
                  <a href={hash} onClick={scrollToSection}>{label}</a>
                </li>
              ))}


            </ul>

            <div class="colour-picker inverted">
              <div>
                <h2 class="inverted" for="base-color-input">Pick a colour:    </h2>

                <input
                  type="color"
                  id="base-color-input"
                  onInput={(event) => { handleColorChange(event.target.value) }}
                  value={backgroundColour} />

              </div>
            </div>



          </div>
          <div className={styles.wrapper3d} id='sectionroot'>
            <div className={`${styles.fold} ${styles.foldTop}`}>
              <div className={styles.foldAlign} id="top-fold">
                <div data-fold-content="true">
                  <Content />

                </div>
              </div>
            </div>
            <div className={styles.fold} id="center-fold">
              <div className={styles.foldAlign}>
                <div data-fold-content="true" id="center-content">
                  <Content />

                </div>
              </div>
            </div>
            <div className={`${styles.fold} ${styles.foldBottom}`}>
              <div className={styles.foldAlign} id="bottom-fold">
                <div data-fold-content="true">
                  <Content />


                </div>
              </div>
            </div>
          </div>
        </div>


      </PlayProvider>
    </section>
  );
}

export default App;




// this code was stolen from https://www.youtube.com/watch?v=7YaWnHVl7Hk
function getLightnessFromHex(hex) {
  hex = hex.replace(/^#/, '')

  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // Luminance formula (perceived brightness)
  const brightness = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;

  return +(brightness * 100).toFixed(2);

}


